import { render, staticRenderFns } from "./PrescriptionMemed.vue?vue&type=template&id=27c6ead2&scoped=true&"
import script from "./PrescriptionMemed.vue?vue&type=script&lang=js&"
export * from "./PrescriptionMemed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6ead2",
  null
  
)

export default component.exports